
<script setup>
import { ref } from 'vue';
import Multiselect from '@vueform/multiselect'

const props = defineProps(['values', 'options', 'name']);

const model = ref({
    mode: 'tags',
    value: JSON.parse(props.values),
    placeholder: 'Auswählen...',
    closeOnSelect: false,
    searchable: true,
    allowAbsent: true,
    options: JSON.parse(props.options),
    noResultsText: 'Keine weiteren Einträge.',
    noOptionsText: 'Keine Einträge gefunden.',
    createOption: true
});
</script>

<template>
    <Multiselect v-model="model.value" v-bind="model" />
    <input class="tw-hidden" :name="props.name" :value="JSON.stringify(model.value)">
</template>
